import React from "react";
import { Link } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { useDatosAlta } from "../lib/planes";

export default function DemoExpiredModal({ show }) {
  // TEN.4: el hook va ANTES del return temprano (reglas de hooks).
  const contacto = useDatosAlta().datos?.contacto_email;
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/75 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <LockKeyhole className="w-8 h-8 text-red-500" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-3">
          Tu periodo de prueba ha terminado
        </h2>
        <p className="text-slate-500 text-base leading-relaxed mb-7">
          Activa tu plan para seguir usando Surit Clínicas y conservar todos tus datos
          — pacientes, citas y configuraciones.
        </p>
        <Link
          to="/app/onboarding"
          className="block w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white py-3.5 px-6 rounded-xl font-semibold text-base transition-colors"
        >
          Activar plan →
        </Link>
        {contacto && (
        <p className="text-xs text-slate-400 mt-5">
          ¿Preguntas?{" "}
          <a href={`mailto:${contacto}`} className="text-blue-500 hover:underline">
            {contacto}
          </a>
        </p>
        )}
      </div>
    </div>
  );
}
